import { supabase } from '@/integrations/supabase/client';

export interface PendingConfirmation {
  negotiation_id: string;
  listing_title: string;
  listing_type: string;
  other_user_id: string;
  other_user_name: string;
  other_user_avatar: string | null;
  confirmed_at: string;
  user_role: 'buyer' | 'seller';
}

/**
 * Fetch negotiations where the other party confirmed completion 3+ days ago
 * and the current user has NOT yet confirmed/cancelled/reported.
 */
export async function fetchPendingConfirmations(): Promise<PendingConfirmation[]> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return [];

  const { data, error } = await supabase.rpc('fetch_pending_confirmations', {
    p_user_id: user.id
  });

  if (error) {
    console.error('Error fetching pending confirmations:', error);
    return [];
  }

  return (data || []).map((item: any) => ({
    negotiation_id: item.negotiation_id,
    listing_title: item.listing_title,
    listing_type: item.listing_type,
    other_user_id: item.other_user_id,
    other_user_name: item.other_user_name || 'Usuário',
    other_user_avatar: item.other_user_avatar,
    confirmed_at: item.confirmed_at,
    user_role: item.user_role as 'buyer' | 'seller',
  }));
}
